'use client';
import useClickOutside from '@/hooks/use-click-outside';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';

interface ResolutionTabsProperty {
  className?: string;
  tabs: { label: string; value: number | string }[];
  onClick?: (index: number) => void;
  limit?: number;
  defaultIndex?: number;
}

export const ResolutionTabs: React.FC<ResolutionTabsProperty> = ({ tabs, onClick, limit, defaultIndex = 1 }) => {
  const [current, setCurrent] = useState(defaultIndex);
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const onChangeTab = (index: number) => () => {
    setCurrent(index);
    onClick?.(index);
  };

  const dropdownRef = useRef(null);
  const isShowMore = limit && tabs.length > limit;
  const visibleTabs = isShowMore ? tabs.slice(0, limit) : tabs;
  const moreLabel = limit && current < limit ? '更多' : tabs[current].label;

  const onClickMore = () => {
    setIsOpenDropdown(v => !v);
  };

  const handleClickOutside = () => setIsOpenDropdown(false);

  useClickOutside(dropdownRef, handleClickOutside);

  return (
    <ul className='flex items-center rounded-[10px] bg-[#f6f8fc] px-1 py-[3px] text-sm text-[#515c69] lg:mr-5'>
      {visibleTabs.map(({ label }, index) => {
        const isActive = index === current;

        return (
          <li
            key={label}
            className={classnames('flex-1 cursor-pointer rounded-lg py-[2px] text-center', {
              'border border-[#e2e8f1] bg-white text-[#e03f19] shadow-tab-menu': isActive
            })}
            onClick={onChangeTab(index)}
          >
            {label}
          </li>
        );
      })}
      {isShowMore && (
        <li
          key='more'
          className={classnames(
            'relative flex flex-1 cursor-pointer items-center justify-center rounded-lg py-[2px] text-center leading-4 after:ml-1 after:mt-[-2px] after:h-[16px] after:w-[10px] after:content-dropdown',
            {
              'bg-white text-[#e03f19]': current >= limit
            }
          )}
          onClick={onClickMore}
        >
          {moreLabel}
          {isOpenDropdown && (
            <ul className='absolute top-6 z-10 bg-white text-[#515c69] shadow-dropdown' ref={dropdownRef}>
              {tabs.slice(limit).map(({ label }, index) => (
                <li key={label} className='w-full bg-white px-3 py-2 leading-6' onClick={onChangeTab(index + limit)}>
                  {label}
                </li>
              ))}
            </ul>
          )}
        </li>
      )}
    </ul>
  );
};

export default ResolutionTabs;
